
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Procurement } from '@/types/procurement';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { PlusCircle } from 'lucide-react';

type RecentProcurementsProps = {
  procurements: Procurement[];
};

const RecentProcurements = ({ procurements }: RecentProcurementsProps) => {
  const navigate = useNavigate();

  // Helper function to render the status of a procurement
  const renderStatus = (status: string) => {
    return (
      <span className={`px-2 py-0.5 rounded-full text-xs ${
        status === 'Analyserad' 
          ? 'bg-green-100 text-green-800' 
          : status === 'Pågående'
            ? 'bg-yellow-100 text-yellow-800'
            : 'bg-blue-100 text-blue-800'
      }`}>
        {status}
      </span>
    );
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Senaste upphandlingar</CardTitle>
        <CardDescription>Dina senast tillagda upphandlingar</CardDescription>
      </CardHeader>
      <CardContent>
        {procurements.length === 0 ? (
          <div className="text-center py-6">
            <p className="text-gray-500 mb-4">Inga upphandlingar tillagda ännu</p>
            <Button 
              variant="outline" 
              size="sm"
              onClick={() => navigate('/new-procurement')}
            >
              <PlusCircle className="h-4 w-4 mr-2" />
              Skapa din första
            </Button>
          </div>
        ) : (
          <div className="space-y-4">
            {procurements.map((proc) => (
              <div key={proc.id} className="border-b pb-3 last:border-0">
                <div className="font-medium">{proc.title}</div>
                <div className="text-sm text-gray-500 flex justify-between mt-1">
                  <span>{new Date(proc.created_at).toLocaleDateString('sv-SE')}</span>
                  {renderStatus(proc.status)}
                </div>
              </div>
            ))}
            <Button 
              variant="outline" 
              className="w-full mt-4" 
              onClick={() => navigate('/procurements')}
            >
              Visa alla
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default RecentProcurements;
